function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LoadNFTsTemplate = require('./load-nfts.template');
var SaitoNFT = require('./../../../../../lib/saito/ui/saito-nft/saito-nft');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var FileUploadOverlay = require('./file-upload');
var WitnessOverlay = require('./witness');
var LoadNFTs = /*#__PURE__*/function () {
  function LoadNFTs(app, mod) {
    var _this = this;
    _classCallCheck(this, LoadNFTs);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.file_upload_overlay = new FileUploadOverlay(this.app, this.mod);
    this.witness_overlay = new WitnessOverlay(this.app, this.mod);
    this.nft_list = [];
    this.vault_nfts = [];
    app.connection.on('vault-file-access-render', function () {
      _this.render();
    });
    app.connection.on('wallet-updated', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$app$options$wal;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!_this.overlay.visible) {
              _context.n = 2;
              break;
            }
            _this.nft_list = ((_this$app$options$wal = _this.app.options.wallet) === null || _this$app$options$wal === void 0 ? void 0 : _this$app$options$wal.nfts) || [];
            _context.n = 1;
            return _this.filterNFTList();
          case 1:
            _context.n = 2;
            return _this.renderNFTList();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
  }
  return _createClass(LoadNFTs, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.overlay.show(LoadNFTsTemplate(this.app, this.mod));

              //
              // load nfts from wallet
              //
              _context2.n = 1;
              return this.fetchNFTList();
            case 1:
              this.nft_list = _context2.v;
              _context2.n = 2;
              return this.filterNFTList();
            case 2:
              _context2.n = 3;
              return this.renderNFTList();
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "fetchNFTList",
    value: function () {
      var _fetchNFTList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$app$options$wal2;
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.app.wallet.updateNFTList();
            case 1:
              data = ((_this$app$options$wal2 = this.app.options.wallet) === null || _this$app$options$wal2 === void 0 ? void 0 : _this$app$options$wal2.nfts) || [];
              return _context3.a(2, data);
          }
        }, _callee3, this);
      }));
      function fetchNFTList() {
        return _fetchNFTList.apply(this, arguments);
      }
      return fetchNFTList;
    }()
  }, {
    key: "filterNFTList",
    value: function () {
      var _filterNFTList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this2 = this;
        var _iterator, _step, _loop, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              //
              // reset vault_nfts list for fresh render
              //
              this.vault_nfts = [];
              this.count = this.nft_list.length;
              _iterator = _createForOfIteratorHelper(this.nft_list);
              _context5.p = 1;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var rec, nft, nft_type;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      rec = _step.value;
                      //
                      // create saito-nft object
                      //
                      nft = new SaitoNFT(_this2.app, _this2.mod, null, rec); //
                      // determine nft type
                      //
                      // Canonical types: vault-nft-key (jade/crystal) and vault-nft-rental.
                      // Also accept legacy "vault" mints.
                      nft_type = nft.returnType();
                      if (!(nft_type === 'store-nft-rental')) {
                        _context4.n = 2;
                        break;
                      }
                      _context4.n = 1;
                      return nft.fetchTransaction(function () {
                        var _nft$tx, _nft$tx$returnMessage;
                        var data = ((_nft$tx = nft.tx) === null || _nft$tx === void 0 || (_nft$tx$returnMessage = _nft$tx.returnMessage) === null || _nft$tx$returnMessage === void 0 || (_nft$tx$returnMessage = _nft$tx$returnMessage.call(_nft$tx)) === null || _nft$tx$returnMessage === void 0 ? void 0 : _nft$tx$returnMessage.data) || {};
                        var file_id = data.file_id;
                        var file_name = data.filename;
                        var file_access_script = data.file_access_script || null;
                        var path = Array.isArray(data.path) ? data.path : [];
                        var hop = _this2.mod.firstUndelegatedHopFromRental(file_access_script, path);
                        var expires_at = hop === null || hop === void 0 ? void 0 : hop.expires_at;
                        if (expires_at == null || Date.now() >= Number(expires_at)) {
                          _this2.count--;
                          return;
                        }
                        nft.expires_at = expires_at;
                        _this2.vault_nfts.push({
                          access_kind: 'rental',
                          nft: nft,
                          nft_id: nft.id,
                          file_id: file_id,
                          file_access_script: file_access_script,
                          file_name: file_name,
                          expires_at: expires_at
                        });
                        _this2.count--;
                      });
                    case 1:
                      _this2.renderNFTList();
                      _context4.n = 5;
                      break;
                    case 2:
                      if (!(nft_type === 'vault-nft-key' || nft_type === 'vault-nft-rental' || nft_type === 'vault')) {
                        _context4.n = 4;
                        break;
                      }
                      _context4.n = 3;
                      return nft.fetchTransaction(function () {
                        var _nft$slip, _nft$slip2, _nft$slip3;
                        console.log('fetched the nft...');
                        var nfttxmsg = nft.tx.returnMessage();
                        var data = nfttxmsg === null || nfttxmsg === void 0 ? void 0 : nfttxmsg.data;
                        var file_id = data === null || data === void 0 ? void 0 : data.file_id;
                        var file_name = data === null || data === void 0 ? void 0 : data.filename;
                        var file_access_script = data === null || data === void 0 ? void 0 : data.file_access_script;
                        console.log(data);

                        // collect utxokeys from nft object
                        //
                        var slip1_utxokey = ((_nft$slip = nft.slip1) === null || _nft$slip === void 0 ? void 0 : _nft$slip.utxo_key) || '';
                        var slip2_utxokey = ((_nft$slip2 = nft.slip2) === null || _nft$slip2 === void 0 ? void 0 : _nft$slip2.utxo_key) || '';
                        var slip3_utxokey = ((_nft$slip3 = nft.slip3) === null || _nft$slip3 === void 0 ? void 0 : _nft$slip3.utxo_key) || '';

                        //
                        // push into vault_nfts array
                        //
                        _this2.vault_nfts.push({
                          access_kind: 'owned',
                          nft_id: nft.id,
                          file_id: file_id,
                          file_access_script: file_access_script || null,
                          file_name: file_name,
                          slip1_utxokey: slip1_utxokey,
                          slip2_utxokey: slip2_utxokey,
                          slip3_utxokey: slip3_utxokey
                        });
                        _this2.count--;
                      });
                    case 3:
                      _this2.renderNFTList();
                      _context4.n = 5;
                      break;
                    case 4:
                      _this2.count--;
                    case 5:
                      return _context4.a(2);
                  }
                }, _loop);
              });
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context5.n = 4;
                break;
              }
              return _context5.d(_regeneratorValues(_loop()), 3);
            case 3:
              _context5.n = 2;
              break;
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t = _context5.v;
              _iterator.e(_t);
            case 6:
              _context5.p = 6;
              _iterator.f();
              return _context5.f(6);
            case 7:
              return _context5.a(2);
          }
        }, _callee4, this, [[1, 5, 6, 7]]);
      }));
      function filterNFTList() {
        return _filterNFTList.apply(this, arguments);
      }
      return filterNFTList;
    }()
  }, {
    key: "renderNFTList",
    value: function () {
      var _renderNFTList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var container, instructionsEl, html, wrapper, i, keyImage, is_rental, label, rental_mark, _html;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              container = document.querySelector('#nft-list');
              if (container) {
                _context6.n = 1;
                break;
              }
              console.warn('LoadNFTs: missing #nft-list container');
              return _context6.a(2);
            case 1:
              instructionsEl = document.querySelector('.vault-nfts #nft-list-instructions');
              if (this.count > 0) {
                if (instructionsEl) {
                  instructionsEl.innerHTML = '';
                }
                html = "<div class=\"loader\"></div>";
                container.innerHTML = html;
              } else if (!this.vault_nfts || this.vault_nfts.length === 0) {
                container.innerHTML = '<div class="send-nft-list"></div>';
                if (instructionsEl) {
                  instructionsEl.innerHTML = "\n          <div class=\"instructions\">\n            You do not yet have any Vault Access Keys in your wallet.\n          </div>\n        ";
                }
              } else {
                if (instructionsEl) {
                  instructionsEl.innerHTML = '';
                }
                //
                // wrapper for cards
                //
                container.innerHTML = "<div class=\"send-nft-list\"></div>";
                wrapper = container.querySelector('.send-nft-list');
                for (i = 0; i < this.vault_nfts.length; i++) {
                  //
                  // determine which key image to display
                  // crystal key = custom/advanced (has file_access_script)
                  // jade key = public/standard (no file_access_script)
                  //
                  keyImage = this.vault_nfts[i].file_access_script ? 'crystal_key.png' : 'jade_key.png';
                  is_rental = this.vault_nfts[i].access_kind === 'rental';
                  label = this.vault_nfts[i].file_name || this.vault_nfts[i].file_id || '';
                  rental_mark = is_rental ? ' <span class="vault-nft-rental-tag">rental</span>' : '';
                  _html = "\n          <div class=\"vault-nft-item\" data-vault-index=\"".concat(i, "\">\n            <img\n              class=\"vault-nft-img\"\n              src=\"/vault/img/").concat(keyImage, "\"\n            />\n\n            <div class=\"vault-nft-footer\">\n              <div class=\"vault-nft-hash\">\n                ").concat(label).concat(rental_mark, "\n              </div>\n              <button class=\"vault-nft-download-btn\">Download</button>\n            </div>\n          </div>\n        "); //
                  // use wrapper and inject as HTML
                  //
                  wrapper.insertAdjacentHTML('beforeend', _html);
                }
              }
              //
              // bind click events after DOM is ready
              //
              this.attachEvents();
            case 2:
              return _context6.a(2);
          }
        }, _callee5, this);
      }));
      function renderNFTList() {
        return _renderNFTList.apply(this, arguments);
      }
      return renderNFTList;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var uploadButtons = document.querySelectorAll('.vault-nfts [data-vault-upload]');
      uploadButtons.forEach(function (uploadButton) {
        uploadButton.onclick = function () {
          _this3.overlay.close();
          _this3.file_upload_overlay.render();
        };
      });
      var items = document.querySelectorAll('.vault-nft-item');
      if (!items || items.length === 0) {
        return;
      }
      items.forEach(function (item) {
        item.onclick = function (e) {
          e.preventDefault();

          //
          // get index from data attribute
          //
          var idx_str = item.getAttribute('data-vault-index');
          var idx = parseInt(idx_str, 10);
          if (Number.isNaN(idx) || !_this3.vault_nfts[idx]) {
            console.warn('LoadNFTs: vault_nft entry not found for index', idx_str);
            return;
          }
          var vault_entry = _this3.vault_nfts[idx];
          console.log('CLICKED: ' + JSON.stringify({
            access_kind: vault_entry.access_kind,
            nft_id: vault_entry.nft_id,
            file_id: vault_entry.file_id,
            file_name: vault_entry.file_name
          }));
          if (vault_entry.access_kind === 'rental') {
            _this3.overlay.hide();
            _this3.mod.sendAccessRentalFileRequest(vault_entry.nft);
            return;
          }

          //
          // Check if this is a custom/advanced key (has file_access_script)
          //
          if (vault_entry.file_access_script) {
            //
            // Show witness overlay for custom keys
            //
            _this3.overlay.hide();
            _this3.witness_overlay.access_script = vault_entry.file_access_script;
            _this3.witness_overlay.vault_entry = vault_entry;
            _this3.witness_overlay.render();
            _this3.witness_overlay.callback = function (result) {
              _this3.mod.sendAccessFileRequest(vault_entry, result.access_script);
            };
          } else {
            //
            // Public key - direct file request (no witness needed)
            //
            _this3.mod.sendAccessFileRequest(vault_entry);
          }
        };
      });
    }
  }]);
}();
module.exports = LoadNFTs;